import { render, staticRenderFns } from "./ExamResultDetail.vue?vue&type=template&id=37ef4589"
import script from "./ExamResultDetail.vue?vue&type=script&lang=js"
export * from "./ExamResultDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports